import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import Swal from 'sweetalert2';
import {
  Add,
  Delete,
  Edit,
  Search as SearchIcon,
  FilterList,
  CalendarToday,
} from '@material-ui/icons';
import httpErrorHandle from '../../Util/httpErrorHandle';
import Table from '../../components/Table';
import BreakCrumbs from '../../components/BreakCrumbs';
import CreateMODMember from '../../components/MemberManagement/CreateMODMember';
import Pagination from '../../components/Pagination';
import '../../style/components/MemberManagememt/member-management.scss';
import Button from '../../components/Button';
import { RadioSelector as MemberFilter } from '../../components/RadioSelector';
import { fetchMembers, createMember } from '../../Util/fetchMethods';
import { logoutSuccess, memberStatusSwitch } from '../../store/action';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  IconButton,
  ListSubheader,
  Paper,
  InputAdornment,
  Box,
  Chip,
  Divider,
} from '@material-ui/core';
import {
  SignUpFromText,
  PCFARM_DEPARTMENTS,
  MemberTypeList,
} from '../../data/common';
import moment from 'moment';
import { DatePicker } from '@material-ui/pickers';
import memberAPI from '../../middleware/memberAPI';
import { trim } from 'lodash';
import { alertError } from '../../Util/Util';

const currentYear = moment().year();
const yearOptions = Array.from(
  { length: currentYear - 1920 + 1 },
  (_, i) => currentYear - i,
);

function MemberList(props) {
  const [members, setMembers] = useState([]);
  const [memberTotalCount, setMemberTotalCount] = useState(0);
  const [page, setPage] = useState({
    rowsPrePage: 10,
    currPage: 1,
    totalPages: 0,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isCreateMember, setIsCreateMember] = useState(false);
  const [memberType, setMemberType] = useState(MemberTypeList.all);
  const [searchText, setSearchText] = useState('');
  const [searchStartDate, setSearchStartDate] = useState(null);
  const [searchEndDate, setSearchEndDate] = useState(null);
  const dispatch = useDispatch();

  // 特約公司管理相關狀態
  const [isCompanyModalOpen, setIsCompanyModalOpen] = useState(false);
  const [currentMember, setCurrentMember] = useState(null);
  const [companyList, setCompanyList] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState('');
  const [selectedDeptType, setSelectedDeptType] = useState('');
  const [deptInputValue, setDeptInputValue] = useState('');
  const [selectedDeptOption, setSelectedDeptOption] = useState('');

  // 修改生日相關狀態
  const [isBirthdayModalOpen, setIsBirthdayModalOpen] = useState(false);
  const [birthdayMember, setBirthdayMember] = useState(null);
  const [birthdayYear, setBirthdayYear] = useState('');
  const [birthdayMonth, setBirthdayMonth] = useState('');
  const [birthdayDay, setBirthdayDay] = useState('');

  const dispatchLogoutSuccess = useMemo(() => {
    return bindActionCreators(logoutSuccess, dispatch);
  }, [dispatch, logoutSuccess]);

  const updateMembers = useCallback(
    (p, rowsPrePage, type, searchText, start, end) => {
      setIsLoading(true);

      fetchMembers(p, rowsPrePage, type, searchText, start, end)
        .then((json) => {
          const {
            MemberList,
            CurrentPage,
            TotalPages,
            TotalCount,
          } = json.Result;
          setMembers(MemberList);
          setPage({
            currPage: CurrentPage,
            totalPages: TotalPages,
            rowsPrePage: rowsPrePage,
          });
          setMemberTotalCount(TotalCount);
        })
        .catch((error) => {
          httpErrorHandle(
            error.httpCode,
            `fetchMembers Error: ${error.msg} httpErrorCode: ${error.httpCode}`,
            dispatchLogoutSuccess,
          );
        })
        .then(() => {
          setIsLoading(false);
        });
    },
    [dispatchLogoutSuccess],
  );

  const inputText = (e) => {
    setSearchText(e.target.value);
  };
  const searchingText = () => {
    updateMembers(
      1,
      page.rowsPrePage,
      memberType,
      searchText,
      searchStartDate,
      searchEndDate,
    );
  };

  /* create MOD member */
  const createModMember = () => {
    setIsCreateMember(true);
  };
  const cancelCreateMember = () => {
    setIsCreateMember(false);
  };
  const createMemberAction = (newMember) => {
    createMember(newMember).then((data) => {
      if (data.Result) {
        Swal.fire({
          icon: 'success',
          title: '新增成功',
          showConfirmButton: true,
          showCloseButton: true,
          confirmButtonText: '確定',
          heightAuto: false,
        }).then((result) => {
          if (result.value) {
            // 取得所有會員的第一頁
            setMemberType(MemberTypeList.all);
            setSearchStartDate(null);
            setSearchEndDate(null);
            setSearchText('');
            updateMembers(1, 10, MemberTypeList.all, '', null, null);
          }
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: '輸入的帳號已存在，請重新輸入。',
          showConfirmButton: true,
          showCloseButton: true,
          confirmButtonText: '確定',
          heightAuto: false,
        });
      }
    });
  };

  const switchMemberState = (id, status) => {
    const newArray = members.map((member) => {
      if (member.Id === id) {
        member.Status = member.Status === 1 ? 2 : 1;
      }
      return member;
    });
    setMembers([...newArray]);
    dispatch(memberStatusSwitch({ UserId: id, Status: status === 1 ? 2 : 1 }));
  };

  /* filter Member*/
  const filterMemberType = (e) => {
    setMemberType(e.target.value);
    updateMembers(
      1,
      page.rowsPrePage,
      e.target.value,
      searchText,
      searchStartDate,
      searchEndDate,
    );
  };
  const filterList = [
    {
      value: MemberTypeList.all,
      type: memberType,
      text: '所有會員',
    },
    {
      value: MemberTypeList.carpDragon,
      type: memberType,
      text: '良師選會員',
    },
    /* 移除 MOD 會員篩選功能 {
      value: MemberTypeList.mod,
      type: memberType,
      text: 'MOD 會員',
    },*/
    {
      value: MemberTypeList.payingMember,
      type: memberType,
      text: 'VIP會員',
    },
    {
      value: MemberTypeList.normalMember,
      type: memberType,
      text: '一般會員',
    },
  ];

  const getSignUpFromText = (signUpFrom) => {
    return SignUpFromText[signUpFrom]
      ? SignUpFromText[signUpFrom]
      : signUpFrom === null
      ? '一般註冊'
      : signUpFrom;
  };

  // 特約公司管理功能
  const openCompanyModal = (member) => {
    setCurrentMember(member);
    setIsCompanyModalOpen(true);
    // 載入公司列表
    memberAPI
      .getCompanyList()
      .then((response) => {
        if (response) {
          setCompanyList(response);

          // 如果會員已有特約公司設定，預填第一個
          if (member.CompanyList && member.CompanyList.length > 0) {
            const firstCompany = member.CompanyList[0];

            // 設定公司ID
            if (firstCompany.CompanyId) {
              setSelectedCompanyId(firstCompany.CompanyId);

              // 如果是 CompanyId = 1 且有部門資訊，解析部門
              if (Number(firstCompany.CompanyId) === 1 && firstCompany.Dept) {
                parseDepartmentInfo(firstCompany.Dept);
              }
            }
          }
        }
      })
      .catch((error) => {
        httpErrorHandle(
          error.httpCode,
          `getCompanyList Error: ${error.msg}`,
          dispatchLogoutSuccess,
        );
      });
  };

  // 解析部門資訊並設定對應的狀態
  const parseDepartmentInfo = (deptString) => {
    if (!deptString || trim(deptString) === '') return;

    // 遍歷 PCFARM_DEPARTMENTS 找到匹配的部門類型
    Object.keys(PCFARM_DEPARTMENTS).forEach((key) => {
      const deptConfig = PCFARM_DEPARTMENTS[key];

      if (deptString.startsWith(deptConfig.name)) {
        setSelectedDeptType(key);

        // 根據 useValue 類型解析後續內容
        if (deptConfig.useValue === 'input') {
          // 格式: 部門-xxx
          const parts = deptString.split('-');
          if (parts.length > 1) {
            setDeptInputValue(parts.slice(1).join('-')); // 處理可能有多個 - 的情況
          }
        } else if (deptConfig.useValue === 'name') {
          // 格式: 家政班 (不需要額外處理)
          // 已經設定了 selectedDeptType
        } else if (deptConfig.useValue === 'nameAndSelect') {
          // 格式: 長青班-江翠
          const parts = deptString.split('-');
          if (parts.length > 1) {
            setSelectedDeptOption(parts.slice(1).join('-'));
          }
        }
      }
    });
  };

  const closeCompanyModal = () => {
    setIsCompanyModalOpen(false);
    setCurrentMember(null);
    setSelectedCompanyId('');
    setSelectedDeptType('');
    setDeptInputValue('');
    setSelectedDeptOption('');
  };

  const handleAddCompany = () => {
    if (!selectedCompanyId) {
      Swal.fire({
        icon: 'warning',
        title: '請選擇公司',
        heightAuto: false,
      });
      return;
    }

    let department = '';

    if (Number(selectedCompanyId) === 1) {
      // 需要部門資訊
      if (!selectedDeptType) {
        Swal.fire({
          icon: 'warning',
          title: '請選擇部門類型',
          heightAuto: false,
        });
        return;
      }

      const deptConfig = PCFARM_DEPARTMENTS[selectedDeptType];
      if (deptConfig.useValue === 'input') {
        department =
          deptConfig.name +
          (trim(deptInputValue) !== '' ? `-${trim(deptInputValue)}` : '');
      } else if (deptConfig.useValue === 'name') {
        department = deptConfig.name;
      } else if (deptConfig.useValue === 'nameAndSelect') {
        department =
          deptConfig.name +
          (trim(selectedDeptOption) !== ''
            ? `-${trim(selectedDeptOption)}`
            : '');
      }
    }

    setIsLoading(true);
    memberAPI
      .addOrEditDepartment(department, selectedCompanyId, currentMember.Id)
      .then((response) => {
        if (response) {
          Swal.fire({
            icon: 'success',
            title: '新增成功',
            heightAuto: false,
          });
          closeCompanyModal();
          // 重新載入會員列表
          updateMembers(
            page.currPage,
            page.rowsPrePage,
            memberType,
            searchText,
            searchStartDate,
            searchEndDate,
          );
        }
      })
      .catch((error) => {
        httpErrorHandle(
          error.httpCode,
          `addOrEditDepartment Error: ${error.msg}`,
          dispatchLogoutSuccess,
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleDeleteCompany = (memberCompanyId) => {
    Swal.fire({
      title: '確認刪除?',
      text: '刪除後將無法復原',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: '確定',
      cancelButtonText: '取消',
      heightAuto: false,
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);
        memberAPI
          .deleteDepartment(memberCompanyId)
          .then((response) => {
            if (response) {
              Swal.fire({
                icon: 'success',
                title: '刪除成功',
                heightAuto: false,
              });
              // 重新載入會員列表
              updateMembers(
                page.currPage,
                page.rowsPrePage,
                memberType,
                searchText,
                searchStartDate,
                searchEndDate,
              );
            }
          })
          .catch((error) => {
            httpErrorHandle(
              error.httpCode,
              `deleteDepartment Error: ${error.msg}`,
              dispatchLogoutSuccess,
            );
          })
          .finally(() => {
            setIsLoading(false);
          });
      }
    });
  };

  const getDepartmentOptions = () => {
    if (!selectedDeptType) return [];
    const deptConfig = PCFARM_DEPARTMENTS[selectedDeptType];
    if (deptConfig.useValue === 'nameAndSelect' && deptConfig.options) {
      return deptConfig.options;
    }
    return [];
  };

  // 修改生日功能
  const openBirthdayModal = (member) => {
    setBirthdayMember(member);
    if (member.BirthDate) {
      const date = moment(member.BirthDate);
      if (date.isValid()) {
        setBirthdayYear(date.year());
        setBirthdayMonth(date.month() + 1);
        setBirthdayDay(date.date());
      }
    }
    setIsBirthdayModalOpen(true);
  };

  const closeBirthdayModal = () => {
    setIsBirthdayModalOpen(false);
    setBirthdayMember(null);
    setBirthdayYear('');
    setBirthdayMonth('');
    setBirthdayDay('');
  };

  const getBirthdayDaysInMonth = () => {
    if (birthdayYear && birthdayMonth) {
      return moment(`${birthdayYear}-${birthdayMonth}`, 'YYYY-M').daysInMonth();
    }
    return 31;
  };

  const handleUpdateBirthday = () => {
    if (!birthdayYear || !birthdayMonth || !birthdayDay) {
      Swal.fire({
        icon: 'warning',
        title: '請選擇完整的生日日期',
        heightAuto: false,
      });
      return;
    }

    const birthday = `${birthdayYear}-${String(birthdayMonth).padStart(
      2,
      '0',
    )}-${String(birthdayDay).padStart(2, '0')}`;

    Swal.fire({
      title: '確認修改生日?',
      text: `將生日修改為 ${birthday}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: '確定',
      cancelButtonText: '取消',
      heightAuto: false,
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: '處理中...',
          heightAuto: false,
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        memberAPI
          .updateBirthday(birthdayMember.Id, birthday)
          .then(() => {
            closeBirthdayModal();
            Swal.fire({
              icon: 'success',
              title: '修改成功',
              confirmButtonText: '確定',
              heightAuto: false,
            }).then(() => {
              updateMembers(
                page.currPage,
                page.rowsPrePage,
                memberType,
                searchText,
                searchStartDate,
                searchEndDate,
              );
            });
          })
          .catch((error) => {
            alertError(error);
          });
      }
    });
  };

  useEffect(() => {
    // 載入所有成員，第一頁，每頁十列
    updateMembers(1, 10, MemberTypeList.all, '', null, null);
  }, [updateMembers]);

  const columns = [
    { title: 'No.', field: 'Id', property: true },
    { title: '姓名', field: 'RealName', property: true },
    {
      title: '性別',
      field: 'Gender',
      property: true,
      render: (props) => {
        if (props.Gender === 1) {
          return '男';
        }
        return '女';
      },
    },
    {
      title: '生日',
      field: 'BirthDate',
      property: true,
      render: (props) => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
          }}
          onClick={() => openBirthdayModal(props)}>
          <span>{props.BirthDate || '-'}</span>
          <IconButton
            size="small"
            style={{ padding: '4px', marginLeft: '4px' }}>
            <Edit fontSize="small" />
          </IconButton>
        </div>
      ),
    },
    { title: '手機/MOD帳號', field: 'CellPhone', property: true },
    { title: 'E-mail', field: 'Email', property: false },
    {
      title: 'VIP會員',
      field: 'IsPayingMember',
      property: false,
      render: (props) => {
        return (
          <Checkbox
            checked={props.IsPayingMember === true}
            color="primary"
            disabled={true}
          />
        );
      },
    },
    {
      title: '特約公司',
      field: 'CompanyList',
      property: false,
      render: (props) => {
        return (
          <div>
            {Array.isArray(props.CompanyList) &&
              props.CompanyList.map((company, index) => (
                <div
                  key={index}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '4px',
                  }}>
                  <span style={{ flex: 1 }}>
                    {company.Name}{' '}
                    {trim(company.Dept) !== '' ? ` - ${company.Dept}` : ''}
                  </span>
                  <IconButton
                    size="small"
                    onClick={() => handleDeleteCompany(company.Id)}
                    style={{ padding: '4px' }}>
                    <Delete fontSize="small" />
                  </IconButton>
                </div>
              ))}
            <Button
              variant="outlined"
              size="small"
              startIcon={
                props.CompanyList && props.CompanyList.length > 0 ? (
                  <Edit />
                ) : (
                  <Add />
                )
              }
              onClick={() => openCompanyModal(props)}
              style={{ marginTop: '4px' }}>
              {props.CompanyList && props.CompanyList.length > 0
                ? '修改'
                : '新增'}
            </Button>
          </div>
        );
      },
    },
    { title: '推薦人', field: 'RecommendUserId', property: false },
    {
      title: 'Line綁定',
      field: 'IsBindingLine',
      property: false,
      render: (props) => (
        <Checkbox
          checked={props.IsBindingLine === true}
          color="primary"
          disabled={true}
        />
      ),
    },
    {
      title: '註冊來源',
      field: 'SignUpFrom',
      property: false,
      render: (props) => <div>{getSignUpFromText(props.SignUpFrom)}</div>,
    },
    {
      title: '註冊日',
      field: 'SignUpAt',
      property: false,
      render: (props) => (
        <div>{moment(props.SignUpAt).format('YYYY-MM-DD')}</div>
      ),
    },
    {
      title: '購買紀錄',
      field: 'Authority',
      property: false,
      render: (props) => (
        <NavLink
          to={`/MemberManagement/BougthRecord/${props.Id}?name=${props.RealName}`}>
          查詢
        </NavLink>
      ),
    },
    {
      title: '狀態',
      field: 'Status',
      property: false,
      render: (props) => (
        <Checkbox
          checked={props.Status === 2}
          color="primary"
          onChange={() => {
            switchMemberState(props.Id, props.Status);
          }}
        />
      ),
    },
  ];

  const gotoPage = (p) => {
    updateMembers(
      p,
      page.rowsPrePage,
      memberType,
      searchText,
      searchStartDate,
      searchEndDate,
    );
  };

  const pageSize = (e) => {
    updateMembers(
      page.currPage,
      e.target.value,
      memberType,
      searchText,
      searchStartDate,
      searchEndDate,
    );
  };

  const handleChangeStartDate = (date) => {
    setSearchStartDate(
      date !== null ? moment(date).format('YYYY-MM-DD') : null,
    );
  };

  const handleChangeEndDate = (date) => {
    setSearchEndDate(date !== null ? moment(date).format('YYYY-MM-DD') : null);
  };

  useEffect(() => {
    updateMembers(
      1,
      page.rowsPrePage,
      memberType,
      searchText,
      searchStartDate,
      searchEndDate,
    );
  }, [searchStartDate, searchEndDate]);

  useEffect(() => {
    if (isLoading) {
      Swal.showLoading();
    } else {
      Swal.close();
      Swal.hideLoading();
    }
  }, [isLoading]);

  return (
    <div className="member-managemenet member-list pagefadeIn">
      <BreakCrumbs path={props.match.url} />
      <div className="block">
        <div className="form-group" style={{ display: 'block', width: '100%' }}>
          {/* 搜尋與篩選區塊 - 現代化設計 */}
          <Paper
            elevation={0}
            style={{
              marginBottom: '32px',
              border: '1px solid #e5e7eb',
              borderRadius: '12px',
              overflow: 'hidden',
              transition: 'box-shadow 0.3s ease',
            }}>
            {/* 篩選器區域 */}
            <Box
              style={{
                padding: '20px 24px',
                background:
                  'linear-gradient(to bottom, #fafbfc 0%, #ffffff 100%)',
              }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '16px',
                }}>
                <FilterList
                  style={{ fontSize: 20, color: '#6b7280', marginRight: 8 }}
                />
                <span
                  style={{
                    fontSize: '14px',
                    fontWeight: 600,
                    color: '#374151',
                    letterSpacing: '0.02em',
                  }}>
                  會員篩選
                </span>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  alignItems: 'center',
                  gap: '12px',
                }}>
                <Button
                  variant="contained"
                  size="small"
                  startIcon={<Add />}
                  onClick={createModMember}
                  style={{
                    borderRadius: '8px',
                    textTransform: 'none',
                    fontWeight: 500,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    transition: 'all 0.2s ease',
                  }}>
                  新增會員
                </Button>
                <Divider
                  orientation="vertical"
                  flexItem
                  style={{ margin: '0 4px' }}
                />
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    gap: '8px',
                  }}>
                  {filterList.map((item) => {
                    return (
                      <MemberFilter
                        key={item.value}
                        textColor={
                          item.value === MemberTypeList.mod
                            ? 'secondary'
                            : 'initial'
                        }
                        color={
                          item.value === MemberTypeList.mod
                            ? 'secondary'
                            : 'primary'
                        }
                        value={Number(item.value)}
                        type={Number(item.type)}
                        onChange={filterMemberType}
                        text={item.text}
                      />
                    );
                  })}
                </div>
              </div>
            </Box>

            <Divider />

            {/* 搜尋與日期篩選區域 */}
            <Box style={{ padding: '20px 24px', background: '#ffffff' }}>
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  alignItems: 'flex-end',
                  gap: '16px',
                }}>
                {/* 搜尋框 */}
                <div style={{ flex: '1 1 280px', minWidth: '280px' }}>
                  <TextField
                    fullWidth
                    placeholder="搜尋姓名或手機關鍵字..."
                    value={searchText}
                    onChange={inputText}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        searchingText();
                      }
                    }}
                    variant="outlined"
                    size="small"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon style={{ color: '#9ca3af' }} />
                        </InputAdornment>
                      ),
                      endAdornment: searchText && (
                        <InputAdornment position="end">
                          <IconButton
                            size="small"
                            onClick={() => {
                              setSearchText('');
                            }}
                            style={{ padding: 4 }}>
                            <Delete style={{ fontSize: 18 }} />
                          </IconButton>
                        </InputAdornment>
                      ),
                      style: {
                        borderRadius: '8px',
                        background: '#f9fafb',
                        transition: 'all 0.2s ease',
                      },
                    }}
                    style={{
                      transition: 'all 0.2s ease',
                    }}
                  />
                </div>

                {/* 日期選擇器 */}
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    flexWrap: 'wrap',
                  }}>
                  <DatePicker
                    autoOk
                    label="註冊開始日期"
                    clearable
                    disableFuture
                    value={searchStartDate}
                    onChange={handleChangeStartDate}
                    format="yyyy/MM/dd"
                    inputVariant="outlined"
                    size="small"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <CalendarToday
                            style={{ fontSize: 18, color: '#9ca3af' }}
                          />
                        </InputAdornment>
                      ),
                      style: {
                        borderRadius: '8px',
                        background: '#f9fafb',
                      },
                    }}
                    style={{ width: '180px' }}
                  />
                  <span
                    style={{
                      color: '#9ca3af',
                      fontSize: '14px',
                      fontWeight: 500,
                    }}>
                    至
                  </span>
                  <DatePicker
                    autoOk
                    label="註冊結束日期"
                    clearable
                    disableFuture
                    value={searchEndDate}
                    onChange={handleChangeEndDate}
                    format="yyyy/MM/dd"
                    inputVariant="outlined"
                    size="small"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <CalendarToday
                            style={{ fontSize: 18, color: '#9ca3af' }}
                          />
                        </InputAdornment>
                      ),
                      style: {
                        borderRadius: '8px',
                        background: '#f9fafb',
                      },
                    }}
                    style={{ width: '180px' }}
                  />
                </div>

                {/* 總計顯示 */}
                <div style={{ marginLeft: 'auto' }}>
                  <Chip
                    label={
                      <span
                        style={{
                          fontVariantNumeric: 'tabular-nums',
                          fontWeight: 600,
                        }}>
                        總計 {memberTotalCount} 位會員
                      </span>
                    }
                    style={{
                      background:
                        'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      color: '#ffffff',
                      fontWeight: 600,
                      fontSize: '14px',
                      height: '36px',
                      borderRadius: '8px',
                      boxShadow: '0 2px 8px rgba(102,126,234,0.3)',
                    }}
                  />
                </div>
              </div>
            </Box>
          </Paper>

          <Table columns={columns} datas={members} />
          <div className="pagination-box">
            <Pagination
              currPage={page.currPage}
              totalPage={page.totalPages}
              onChangPage={gotoPage}
            />
            <div className="view-single-page">
              每頁顯示
              <select value={page.rowsPrePage} onChange={pageSize}>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
              </select>
            </div>
          </div>
          <CreateMODMember
            isOpen={isCreateMember}
            close={cancelCreateMember}
            create={createMemberAction}
          />
        </div>
      </div>

      {/* 特約公司設定 Modal */}
      <Dialog
        open={isCompanyModalOpen}
        onClose={closeCompanyModal}
        maxWidth="sm"
        fullWidth>
        <DialogTitle>設定特約公司</DialogTitle>
        <DialogContent>
          {currentMember && (
            <div>
              <p style={{ marginBottom: '16px' }}>
                會員: {currentMember.RealName} ({currentMember.CellPhone})
              </p>

              <FormControl fullWidth margin="normal">
                <InputLabel>選擇公司</InputLabel>
                <Select
                  value={selectedCompanyId}
                  disabled={isLoading}
                  onChange={(e) => {
                    setSelectedCompanyId(e.target.value);
                    setSelectedDeptType('');
                    setDeptInputValue('');
                    setSelectedDeptOption('');
                  }}>
                  {companyList.map((company) => (
                    <MenuItem key={company.id} value={company.id}>
                      {company.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {Number(selectedCompanyId) === 1 && (
                <>
                  <FormControl fullWidth margin="normal">
                    <InputLabel>選擇部門類型</InputLabel>
                    <Select
                      value={selectedDeptType}
                      disabled={isLoading}
                      onChange={(e) => {
                        setSelectedDeptType(e.target.value);
                        setDeptInputValue('');
                        setSelectedDeptOption('');
                      }}>
                      {Object.keys(PCFARM_DEPARTMENTS).map((key) => (
                        <MenuItem key={key} value={key}>
                          {PCFARM_DEPARTMENTS[key].name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  {selectedDeptType &&
                    PCFARM_DEPARTMENTS[selectedDeptType].useValue ===
                      'input' && (
                      <TextField
                        fullWidth
                        disabled={isLoading}
                        margin="normal"
                        label="輸入部門名稱"
                        value={deptInputValue}
                        onChange={(e) => setDeptInputValue(e.target.value)}
                      />
                    )}

                  {selectedDeptType &&
                    PCFARM_DEPARTMENTS[selectedDeptType].useValue ===
                      'nameAndSelect' && (
                      <FormControl fullWidth margin="normal">
                        <InputLabel>選擇班級</InputLabel>
                        <Select
                          value={selectedDeptOption}
                          disabled={isLoading}
                          onChange={(e) =>
                            setSelectedDeptOption(e.target.value)
                          }>
                          {getDepartmentOptions().map((group) => [
                            <ListSubheader key={group.groupName}>
                              {group.groupName}
                            </ListSubheader>,
                            ...group.className.map((className) => (
                              <MenuItem key={className} value={className}>
                                {className}
                              </MenuItem>
                            )),
                          ])}
                        </Select>
                      </FormControl>
                    )}
                </>
              )}
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={closeCompanyModal} color="default">
            取消
          </Button>
          <Button
            onClick={handleAddCompany}
            color="primary"
            variant="contained">
            設定
          </Button>
        </DialogActions>
      </Dialog>

      {/* 修改生日 Modal */}
      <Dialog
        open={isBirthdayModalOpen}
        onClose={closeBirthdayModal}
        maxWidth="sm"
        fullWidth>
        <DialogTitle>修改生日</DialogTitle>
        <DialogContent>
          {birthdayMember && (
            <div>
              <p style={{ marginBottom: '16px' }}>
                會員: {birthdayMember.RealName} ({birthdayMember.CellPhone})
              </p>

              <div
                style={{
                  display: 'flex',
                  gap: '16px',
                  alignItems: 'flex-end',
                }}>
                <FormControl style={{ flex: 1 }} margin="normal">
                  <InputLabel>年</InputLabel>
                  <Select
                    value={birthdayYear}
                    onChange={(e) => {
                      setBirthdayYear(e.target.value);
                      const maxDay = moment(
                        `${e.target.value}-${birthdayMonth || 1}`,
                        'YYYY-M',
                      ).daysInMonth();
                      if (birthdayDay > maxDay) setBirthdayDay(maxDay);
                    }}>
                    {yearOptions.map((y) => (
                      <MenuItem key={y} value={y}>
                        {y}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <FormControl style={{ flex: 1 }} margin="normal">
                  <InputLabel>月</InputLabel>
                  <Select
                    value={birthdayMonth}
                    onChange={(e) => {
                      setBirthdayMonth(e.target.value);
                      const maxDay = moment(
                        `${birthdayYear || currentYear}-${e.target.value}`,
                        'YYYY-M',
                      ).daysInMonth();
                      if (birthdayDay > maxDay) setBirthdayDay(maxDay);
                    }}>
                    {Array.from({ length: 12 }, (_, i) => i + 1).map((m) => (
                      <MenuItem key={m} value={m}>
                        {m}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <FormControl style={{ flex: 1 }} margin="normal">
                  <InputLabel>日</InputLabel>
                  <Select
                    value={birthdayDay}
                    onChange={(e) => setBirthdayDay(e.target.value)}>
                    {Array.from(
                      { length: getBirthdayDaysInMonth() },
                      (_, i) => i + 1,
                    ).map((d) => (
                      <MenuItem key={d} value={d}>
                        {d}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={closeBirthdayModal} bgcolor="cancel">
            取消
          </Button>
          <Button
            onClick={handleUpdateBirthday}
            color="primary"
            variant="contained">
            確認
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default MemberList;
